export default {
  props: ['id'],
  data() {
    return {
      dialog: {
        active: false,
        content: '',
      },
    };
  },
  computed: {
    instruction() {
      return this.$store.state.news.instruction;
    },
  },
  methods: {
    showPDF(url) {
      this.dialog.active = true;
      this.dialog.content = `<iframe src="${url}" style="width:100%; min-height:700px" frameborder="0"></iframe>`;
    },
  },
  created() {
    this.$store.dispatch('news/GetInstruction', this.$props.id);
  },
};
